import React from "react";
import useOneTapAuth from "@/hooks/useOneTapAuth";
import { MIXPANEL_REGISTER_LOCATION_FEED } from "@/constants/mixpanel.constants";
import SignUpContent from "./SignUpContent";

interface SignUpCardProps {
    onDismiss?: () => void;
    redirectPath?: string;
    version?: string;
    location?: string;
}

/**
 * SignUpCard component displays an in-feed prompt to register or sign in
 * @param props - Component props
 * @returns {JSX.Element} SignUpCard component
 */
const SignUpCard: React.FC<SignUpCardProps> = ({
    onDismiss,
    redirectPath = "/puzzle",
    version = "puzzle",
    location = MIXPANEL_REGISTER_LOCATION_FEED,
}) => {
    const { shouldShow, handleGoogle, handleEmail } = useOneTapAuth({ redirectPath, version, location });

    // Don't show if already authenticated
    if (!shouldShow) {
        return null;
    }

    return (
        <div className="tw-w-full tw-max-w-[640px] tw-mx-auto tw-my-4 tw-bg-white tw-border tw-border-gray-200 tw-shadow-md tw-p-4">
            <SignUpContent onGoogle={handleGoogle} onEmail={handleEmail} onDismiss={onDismiss} />
        </div>
    );
};

export default SignUpCard;
